import { render, staticRenderFns } from "./ProyectoPage.vue?vue&type=template&id=5ae6f4db"
import script from "./ProyectoPage.js?vue&type=script&lang=js&external"
export * from "./ProyectoPage.js?vue&type=script&lang=js&external"
import style0 from "./ProyectoPage.vue?vue&type=style&index=0&id=5ae6f4db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports